import { render } from "./RadioButtonTag.vue?vue&type=template&id=e976f462&ts=true"
import script from "./RadioButtonTag.vue?vue&type=script&lang=ts"
export * from "./RadioButtonTag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__